import React from 'react';
import Wrapper from '../../HOC/Wrapper';
import assessmentNotAvailable from '../../assets/images/assessment_not_avalible.png';
import styles from './ScheduleContainer.scss';

const ScheduleContainer = () => {
  return (
    <Wrapper>
      <div className={styles.scheduleContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>Assessment Not Available Yet</h1>
          <p className={styles.subtitle}>Access before the scheduled time is not allowed.</p>
          <div className={styles.imageContainer}>
            <img
              src={assessmentNotAvailable}
              alt="Assessment Not Available"
              className={styles.image}
            />
            <div className={styles.textOverlay}>
              <p className={styles.overlayText}>
                Please come back at the scheduled time mentioned in your email.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ScheduleContainer;
